import { render } from "./ButtonRemove.vue?vue&type=template&id=54bc933a"
import script from "./ButtonRemove.vue?vue&type=script&lang=js"
export * from "./ButtonRemove.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__